<template>
  <v-overlay
      opacity="1"
      color="#FFFFFF"
      :light="true"
      :dark="false"
  >
    <v-content >
      <v-container
          
          v-if="cShop"
      >
        <v-btn
            text
            x-large
            color="primary"
            @click="onClickBack"
            style="padding-left:0"
        >
          ZURÜCK
        </v-btn>
        <div class="headline black--text">{{ cShop.title }}</div>
        <v-row>
          <v-col
              cols="12"
                            md="6"
              xl="4"

          >
            <v-img
            cover
            class="white--text align-end"
            max-height="400px"
            :src="cImgUrl">
            </v-img>
          </v-col>
          <v-col
              cols="12"
                            md="6"
              xl="4"
          >
            <v-list color="white" >
              <v-list-item class="black--text">
                {{ cShop.descr }}
              </v-list-item>
              <v-list-item
                  v-for="item in cList"
                  :key="item.key"
              >
                <v-list-item-avatar>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-if="item.text">
                    {{ item.text }}
                  </v-list-item-title>
                  <v-list-item-subtitle
                      v-if="item.link"
                  >
                    <a :href="item.link" target="_blank">{{ item.linkText }}</a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col
              cols="12"
              xl="4"
          >
            <RTMap v-if="cShop && cShop.lat && cShop.lng"
                :items="[cShop]"
                :initialZoom="16"
                :height="'300px'"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-overlay>
</template>

<script>
import shops from '@/assets/shops';
import {categoryBase} from '@/mixins/categoryBase.js'
import {helper} from '@/mixins/helper.js'
import {shopBase} from '@/mixins/shopBase.js'

import RTMap from '@/components/map/RTMap'

export default {
  name: 'ShopView',
  mixins:[helper,categoryBase,shopBase],
  components: {
    RTMap
  },
  props:['id'],
  data: () => ({
  }),
  watch:{
    show(visible){
      if(!visible){
        this.onClose();
      }
    }
  },
  computed:{
    cImgUrl () {
        return this.cShop.img ? this.getModifiedImage(this.cShop.img) : ""
    },
    cShop () {
      return shops.find(el => el.id === this.$route.params.id)
    },
    cList () {
      const list = []

        if (this.cShop.company) {
            list.push({
                icon: 'mdi-office-building',
                text: this.cShop.company
            })
        }
        if (this.cShop.url) {
            list.push({
                icon: 'mdi-earth',
                linkText:this.cShop.url,
                link: this.cShop.url
            })
        }

        if (this.cShop.ship && this.cShop.ship.length>0) {
            list.push({
                icon: 'mdi-truck',
                text: this.getShippingAsString(this.cShop),
            })
        }

        if (this.cShop.category && this.cShop.category.length>0) {
            list.push({
                icon: 'mdi-tag-multiple',
                text: this.getCategoriesAsString(this.cShop.category),
            })
        }

      /*
      //Kontakt
      name, lastname
          "c_city": "",
    "plz": "",
    "street": "",

        if (this.shop.tel) {
            list.push({
                icon: 'mdi-tel',
                text: 'Telefon',
                linkText: this.shop.tel,
                link: 'tel:'+this.shop.tel
            })
        }

        if (this.shop.email) {
            list.push({
                icon: 'mdi-mail',
                text: 'E-Mail',
                linkText: this.shop.email,
                link: 'tel:'+this.shop.email
            })
        }*/

        return list
    }
  },
  methods:{
    close () {
      this.$router.go(-1);
    },
    onClickBack(){
      this.close();
    },
    getDefaultMailTextForEntry(shop){
      let id=(shop)?shop.id:"?";
      return "Hallo, ich habe folgendes Anliegen zum Beitrag https://handelt-gemeinsam.de/shop/"+id+": "
    },
    enhanceData (shop) {
      if (shop) {
        shop.shipText = this.getShippingAsString(shop)
        shop.img = this.getModifiedImage(shop.img)
      }
      return shop;
    }
  }
};
</script>


<style lang="css">
  .v-overlay__content{
    width:100%;
  }
</style>

<style scoped lang='scss'>
  ::v-deep {
    .v-overlay__content {
      height: 100%;
      overflow: auto;
    }
  }


</style>
